import {
  BarChart,
  // LineChart,
} from '@mui/x-charts'
import { Box } from '@mui/material'
import { useEffect, useState } from 'react'

const TestCasesAccordionCharts = (props) => {
    const { testCasesData } = props;
    
    const [chartData, setChartData] = useState({});
    console.log("chartData:", chartData);
    console.log("testCasesData:", testCasesData);

  const labels = Object.keys(chartData);
  const passedData = labels.map(item => chartData[item].passed);
  const failedData = labels.map(item => chartData[item].failed);
  const generatedData = labels.map(item => chartData[item].generated);

  useEffect(() => {
    if (!testCasesData) return;
    const newChartData = {};
    testCasesData.forEach((item) => {
      const date = new Date(); // Replace with item.date if available
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      const key = `${month}/${day}/${year}`;

      let chartDataItem = newChartData[key];
      if (!chartDataItem) chartDataItem = { passed: 0, failed: 0, generated: 0 };

      const formattedItem = {
        passed: chartDataItem.passed + (item.status === "COMPLETED" ? 1 : 0),
        failed: chartDataItem.failed + (item.status ===  "FAILED" || item.status === "INITIAL_FAILURE" ? 1 : 0),
        generated: chartDataItem.generated + 1,
      }

      newChartData[key] = formattedItem;
    })
    setChartData(newChartData);
  }, [testCasesData])

  return (
    <Box>
      <BarChart
        xAxis={[{ id: 'date', data: labels, scaleType: 'band' }]}
        series={[
          {
            id: 'passed',
            data: passedData,
            label: 'Passed Tests',
            color: '#8bc34a',
          },
          {
            id: 'failed',
            data: failedData,
            label: 'Failed Tests',
            color: '#f44336',
          },
          {
            id: 'generated',
            data: generatedData,
            label: 'Total Tests',
            color: '#2196f3',
          },
        ]}
        height={300}
        margin={{ top: 70, bottom: 30, left: 40, right: 20 }}
      />
      {/* <LineChart
        xAxis={[{ id: 'date', data: labels, scaleType: 'point' }]}
        series={[
          {
            id: 'generated',
            data: generatedData,
            label: 'Generated Tests',
            color: '#2196f3',
            showMark: true,
            curve: 'linear',
          },
          {
            id: 'failed',
            data: failedData,
            label: 'Failed Tests',
            color: '#f44336',
            showMark: true,
            curve: 'linear',
          },
        ]}
        height={300}
        margin={{ top: 70, bottom: 30, left: 40, right: 20 }}
        slotProps={{
          legend: {
            position: { vertical: 'top', horizontal: 'middle' },
            direction: 'row',
          },
        }}
      /> */}
    </Box>
  )
}

export default TestCasesAccordionCharts
